var _style, _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t\t.LightOff-st0 {\r\n\t\t\tfill: currentColor;\r\n\t\t}\r\n\r\n\t\t.LightOff-st1 {\r\n\t\t\tfill: #666666;\r\n\t\t}\r\n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "LightOff-st0",
    d: "M8.4,13c-0.3,0-0.5,0-0.6-0.1s-0.2-0.2-0.3-0.5L5.9,9C5.6,8.4,5.5,8.1,5.6,7.9c0.1-0.2,0.5-0.2,1.2-0.2h9.9 c0.7,0,1,0,1.2,0.2c0.1,0.2,0,0.5-0.3,1.1L16,12.5c-0.1,0.3-0.2,0.4-0.3,0.5c-0.1,0.1-0.3,0.1-0.6,0.1H8.4V13z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "LightOff-st0",
    d: "M5.5,7c0-0.3,0.2-0.5,0.5-0.5h11.5C17.8,6.5,18,6.7,18,7v0.5H5.5V7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "LightOff-st0",
    d: "M7.7,12.5h8v11.1h-8C7.7,23.6,7.7,12.5,7.7,12.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "LightOff-st1",
    d: "M10.3,17.6c0-0.8,0.7-1.4,1.5-1.4s1.5,0.6,1.5,1.4v0.9c0,0.8-0.7,1.4-1.5,1.4s-1.5-0.6-1.5-1.4V17.6z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.3,
    y: -0.9,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -5.0025 12.0513)",
    className: "LightOff-st1",
    width: 1.5,
    height: 26
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOff);
export default __webpack_public_path__ + "static/media/LightOff.9964e268d0d94cd413d0bad007c26ad4.svg";
export { ForwardRef as ReactComponent };